import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCrr3Tnc1V91QuqFn5ZoTtZTlFjWiJlBVQ",
  authDomain: "woven-nova-430315-k7.firebaseapp.com",
  projectId: "woven-nova-430315-k7",
  storageBucket: "woven-nova-430315-k7.firebasestorage.app",
  messagingSenderId: "929033263052",
  appId: "1:929033263052:web:a8be8568295e0dac4f6f69",
  measurementId: "G-LZWSGCKFFS",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
